import './styles/data-source-details.scss'

import React       from 'react'
import PropTypes   from 'prop-types'

import ScrollableItemList from '../components/ScrollableItemList'
import DetailsSection from '../components/DetailsSection'
import DetailsHeader from '../components/DetailsHeader'
import Loading from '../components/Loading'
import GenericConfigDetails from '../components/GenericConfigDetails'
import SFTPGatewayItem from '../sftpGatewayLog/SFTPGatewayItem'

import api from '../redux/api'

const LOG_PAGE = 10

function mapSFTPGatewayLogs(data) {
  return (data && data.edges)
    ? data.edges.map(({ node }) => node)
    : []
}

export default class DataSourceDetails extends React.Component {
  static propTypes = {
    match:   PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
  }

  state = {
    data: null,
  }

  constructor(props) {
    super(props)
    this.handlePropChange(props)
  }

  UNSAFE_componentWillReceiveProps(props) {
    this.handlePropChange(props)
  }

  handlePropChange(props) {
    const { data } = this.state

    if (!data || props.match.params.id !== this.props.match.params.id) {
      const { id } = props.match.params
      
      api.loadDataSource(id).then((data) => {
        this.setState({ data })
      })
    }
  }

  getSFTPItemRenderer = (node) => {
    return (
      <div className="item-list-item" onClick={() => this.handleLogClicked(node)}>
        <SFTPGatewayItem item={node} history={this.props.history}/>
      </div>
    )
  }

  handleLogClicked = (node) => {
    this.props.history.push(`/sftp-gateway-logs/item/${node.id}`)
  }

  handleLoadNextLogPage = async (cursor) => {
    const result = (await api.loadSFTPGatewayLogs({
      count: LOG_PAGE,
      cursor: cursor,
      filterConfig: {
        dataSource: this.state.data.id
      }
    }))

    const filteredResult = {
      ...result,
      edges: (result && result.edges ? result.edges : []).filter(({ node }) => node)
    }
    
    const newLogs = mapSFTPGatewayLogs(filteredResult)
    const oldLogs = this.state.sftpGatewayLogs || []
    const sftpGatewayLogs    = oldLogs.concat(newLogs)
    
    this.setState({ sftpGatewayLogs })

    return filteredResult
  }

  handleLoadNextLogPageForFTP = async (cursor) => {
    const result = (await api.loadFTPGatewayLogs({
      count: LOG_PAGE,
      cursor: cursor,
      filterConfig: {
        dataSource: this.state.data.id
      }
    }))

    const filteredResult = {
      ...result,
      edges: (result && result.edges ? result.edges : []).filter(({ node }) => node)
    }
    
    const newLogs = mapSFTPGatewayLogs(filteredResult)
    const oldLogs = this.state.ftpGatewayLogs || []
    const ftpGatewayLogs    = oldLogs.concat(newLogs)
    
    this.setState({ ftpGatewayLogs })

    return filteredResult
  }

  renderData() {
    const {
      name,
      description,
      sender,
      receiver,
      dataType,
      type,
      ftpGatewayLogs,
      sftpGatewayLogs,
      config
    } = this.state.data    

    const noItems = sftpGatewayLogs && sftpGatewayLogs.edges.length === 0 && !sftpGatewayLogs.pageInfo.hasNextPage

    const noItemsForFTP = ftpGatewayLogs && ftpGatewayLogs.edges.length === 0 && !ftpGatewayLogs.pageInfo.hasNextPage

    return (
      <div className="data-source-details">
        <DetailsHeader title={name} description={description} type={'DataSource'} />
        <div>
          {sender && (
            <DetailsSection
              title="Sender"
              name={sender.name}
              description={sender.description}
              url={`/data-systems/item/${sender.id}`}
            />
          )}

          {receiver && (
            <DetailsSection
              title="Receiver"
              name={receiver.name}
              description={receiver.description}
              url={`/data-systems/item/${receiver.id}`}
            />
          )}

          {dataType && (
            <DetailsSection
              title="Data Type"
              name={dataType.name}
              description={dataType.description}
              url={`/data-types/item/${dataType.id}`}
            />
          )}

          {config && <GenericConfigDetails title={`${type} Data Source Config`} config={config} />}

          {type === 'SFTP' && !noItems && (
            <div className="sftp-log-details">
              <div className="title">{'Gateway Logs'}</div>

              <ScrollableItemList
                useWindow={true}
                connection={sftpGatewayLogs}
                loadNextPage={this.handleLoadNextLogPage}
                renderNode={this.getSFTPItemRenderer}
              />
            </div>
          )}

          {type === 'FTP' && !noItemsForFTP && (
            <div className="sftp-log-details">
              <div className="title">{'Gateway Logs'}</div>

              <ScrollableItemList
                useWindow={true}
                connection={ftpGatewayLogs}
                loadNextPage={this.handleLoadNextLogPageForFTP}
                renderNode={this.getSFTPItemRenderer}
              />
            </div>
          )}
        </div>
      </div>
    )
  }

  render() {
    return this.state.data
      ? this.renderData()
      : <Loading />
  }
}

